import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { register } from '../../features/auth/authSlice'
// import { ADMIN_REGISTER_RESET } from '../../redux/types'

import '../../styles/modalForm.css'

const Signup = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const { loading, admin } = useSelector((state) => state.authRegister)

	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [message, setMessage] = useState(null)

	const registerSubmitHandler = (e) => {
		e.preventDefault()
		let data = {
			name,
			email,
			phoneNumber,
			password,
		}
		if (password === confirmPassword) {
			dispatch(register(data))
			setName('')
			setEmail('')
			setPhoneNumber('')
			setPassword('')
			setConfirmPassword('')
		} else {
			setMessage('Passwords do not match')
		}
	}

	useEffect(() => {
		if (admin) {
			navigate('/showel/login')
		}

		return () => {
			// dispatch({ type: ADMIN_REGISTER_RESET })
		}
	}, [dispatch, admin])

	const viewHandler2 = () => {
		let pass2 = document.getElementById('password2')
		let view2 = document.getElementById('view2')
		const type2 =
			pass2.getAttribute('type') === 'password' ? 'text' : 'password'
		pass2.setAttribute('type', type2)

		view2.classList.toggle('fa-eye-slash')
	}

	const viewHandler3 = () => {
		let pass3 = document.getElementById('password3')
		let view3 = document.getElementById('view3')
		const type3 =
			pass3.getAttribute('type') === 'password' ? 'text' : 'password'
		pass3.setAttribute('type', type3)

		view3.classList.toggle('fa-eye-slash')
	}

	return (
		<section className='login'>
			<div className='container'>
				<div className='row justify-content-center'>
					<div className='col-lg-5 col-md-9'>
						<div className='login_form'>
							<h4 className='text-center'>
								<strong> ADMIN REGISTER </strong>
							</h4>
							<form className='' onSubmit={registerSubmitHandler}>
								<label className='label'>Name</label>
								<input
									type='text'
									value={name}
									required
									name='name'
									className='form-control mb-3'
									onChange={(e) => setName(e.target.value)}
								/>
								<label className='label'>Email</label>
								<input
									type='email'
									required
									name='email'
									value={email}
									className='form-control mb-3'
									onChange={(e) => setEmail(e.target.value)}
								/>
								<label className='label'>Phone Number</label>
								<input
									type='text'
									required
									name='phone number'
									value={phoneNumber}
									className='form-control mb-3'
									onChange={(e) => setPhoneNumber(e.target.value)}
								/>
								<label className='label'>Password</label>
								<div style={{ position: 'relative' }}>
									<input
										type='password'
										id='password2'
										required
										name='password'
										value={password}
										className='form-control mb-1'
										onChange={(e) => setPassword(e.target.value)}
									/>
									<i
										className='fa fa-eye view'
										id='view2'
										onClick={viewHandler2}
									></i>
								</div>
								<label className='label'>Confirm Password</label>
								<div style={{ position: 'relative' }}>
									<input
										type='password'
										id='password3'
										required
										name='confirm password'
										value={confirmPassword}
										className='form-control mb-1'
										onChange={(e) => setConfirmPassword(e.target.value)}
									/>
									<i
										className='fa fa-eye view'
										id='view3'
										onClick={viewHandler3}
									></i>
								</div>
								<p
									style={{
										color: '#fc1a29',
										marginTop: '.5rem',
										marginBottom: '1rem',
										fontSize: '12px',
									}}
								>
									{message}
								</p>

								<div className='text-center mb-2'>
									<button
										className='form-control modal_btn'
										disabled={
											email && password && name && phoneNumber && !loading
												? false
												: true
										}
									>
										{loading ? (
											<i className='fas fa-spinner fa-spin'></i>
										) : (
											<span className='text-white'>Create</span>
										)}
									</button>
								</div>
								<p className='reset text-center'>
									Already have an account?
									<Link to='/showel/login'>Login here</Link>
								</p>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Signup
